import React, { useContext, useState, useEffect, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getNotifications, deleteAllNotifications, deleteNotificationById } from '../../services/notificationServices';
import { useNavigate } from 'react-router-dom';
/// Image
import profile from '../../../images/user.jpg';
import { Dropdown } from 'react-bootstrap';
import LogoutPage from './Logout';
import { ThemeContext } from '../../../context/ThemeContext';
import { IoMdSunny } from 'react-icons/io';
import { FaMoon } from 'react-icons/fa';
import socket from '../../services/socket';
import { format } from 'date-fns';
import { MdDeleteOutline } from 'react-icons/md';

const Header = ({ onNote }) => {
  const { changeBackground, background } = useContext(ThemeContext);
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(false);
  const [audioUnlocked, setAudioUnlocked] = useState(false); // Tracks if audio is allowed
  const [dropdownOpen, setDropdownOpen] = useState(false); // Track dropdown state
  const navigate=useNavigate()
  const audioRef = useRef(null);
  const [employee,setEmployee]=useState('')
  useEffect(()=>{
    const getEmployeeData = () => {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    };
    const employee = getEmployeeData();
    setEmployee(employee); 

    
  },[])
  useEffect(() => {
    audioRef.current = new Audio('/sounds/notification.mp3');
    audioRef.current.loop = true; // 🔁 Keep playing sound until stopped

    // Fetch notifications on load
    const fetchNotifications = async () => {
      try {
        const data = await getNotifications('Employee');
        setNotifications(data);
        const hasUnread = data.some((notif) => !notif.isRead);
        setUnread(hasUnread);
      } catch (error) {
        console.error('Failed to fetch notifications:', error);
      }
    };

    fetchNotifications();

    // Join the Employee notification room
    socket.emit('joinRoom', 'Employee');

    // Listen for new notifications
    socket.on('notification', (newNotification) => {
      setNotifications((prev) => [newNotification, ...prev]);
      setUnread(true); // Mark as unread

      // Try to play sound automatically
      if (audioUnlocked) {
        console.log('audio')
        playSound();
      }
    });

    return () => {
      socket.off('notification');
    };
  }, [audioUnlocked]); // Depend on audioUnlocked state

  const playSound = () => {
    if (unread && audioRef.current) {
      console.log('playing sound>>')
      audioRef.current.play().catch((err) => console.error('⚠️ Audio autoplay blocked!'));
    }
  };

  const stopSound = () => {
    console.log('🔕 Stopping notification sound...');
    setUnread(false); // Mark as read first
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  // ✅ Unlock Audio on First User Interaction
  useEffect(() => {
    const enableAudio = () => {
      if (!audioUnlocked) {
        audioRef.current
          .play()
          .then(() => {
            console.log('🔊 Audio unlocked!');
            setAudioUnlocked(true); // Now sound will play automatically for future notifications
            audioRef.current.pause(); // Stop playing immediately
          })
          .catch((err) => console.error('Error unlocking audio:', err));
      }
    };

    document.addEventListener('click', enableAudio, { once: true });

    return () => {
      document.removeEventListener('click', enableAudio);
    };
  }, []);
  const handleBgChange = () => {
    if (background.value === 'light') {
      changeBackground({ value: 'dark', label: 'Dark' });
    } else {
      changeBackground({ value: 'light', label: 'Light' });
    }
  };
  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
    if (isOpen) {
      stopSound(); // Stop sound when opening the dropdown
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm('Are you sure you want to delete all notifications?')) return;

    try {
      await deleteAllNotifications();
      setNotifications([]); // Clear notifications from UI
    } catch (error) {
      console.error('Failed to delete notifications:', error);
    }
  };

  // Handle delete single notification
  const handleDeleteById = async (id) => {
    if (!window.confirm('Are you sure you want to delete this notification?')) return;

    try {
      await deleteNotificationById(id);
      setNotifications(notifications.filter((notif) => notif._id !== id)); // Remove from UI
    } catch (error) {
      console.error('Failed to delete notification:', error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown Date';
    return format(new Date(dateString), 'dd MMMM yyyy - hh:mm a');
  };

  return (
    <div className="header border-bottom">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="navbar-collapse justify-content-between">
            <div className="nav-item d-flex align-items-center"></div>
            <ul className="navbar-nav header-right items-center">
              <button className="text-xl" onClick={() => handleBgChange()}>
                {background.value === 'dark' ? <IoMdSunny /> : <FaMoon />}
              </button>

              <Dropdown
                show={dropdownOpen}
                onToggle={handleDropdownToggle}
                as="li"
                className="nav-item dropdown notification_dropdown"
              >
                <Dropdown.Toggle className="nav-link i-false c-pointer" variant="" as="a">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19.375" height="24" viewBox="0 0 19.375 24">
                    <g id="_006-notification" data-name="006-notification" transform="translate(-341.252 -61.547)">
                      <path
                        id="Path_1954"
                        data-name="Path 1954"
                        d="M349.741,65.233V62.747a1.2,1.2,0,1,1,2.4,0v2.486a8.4,8.4,0,0,1,7.2,8.314v4.517l.971,1.942a3,3,0,0,1-2.683,4.342h-5.488a1.2,1.2,0,1,1-2.4,0h-5.488a3,3,0,0,1-2.683-4.342l.971-1.942V73.547a8.4,8.4,0,0,1,7.2-8.314Zm1.2,2.314a6,6,0,0,0-6,6v4.8a1.208,1.208,0,0,1-.127.536l-1.1,2.195a.6.6,0,0,0,.538.869h13.375a.6.6,0,0,0,.536-.869l-1.1-2.195a1.206,1.206,0,0,1-.126-.536v-4.8a6,6,0,0,0-6-6Z"
                        transform="translate(0 0)"
                        fill="#135846"
                        fill-rule="evenodd"
                      />
                    </g>
                  </svg>

                  <span className="badge light text-white bg-primary rounded-circle">{notifications?.length}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end">
                  <PerfectScrollbar className="widget-media dlab-scroll p-3 height380">
                    {notifications.length === 0 ? (
                      <p style={{ textAlign: 'center', marginTop: '10px', color: 'gray' }}>No notifications found</p>
                    ) : (
                      notifications.map((data) => {
                        const handleItemClick = () => {
                          const type = data?.type;
                          const bookingType = data?.bookingType;
                        
                          // Navigate based on type
                          if (type === 'inquiry') {
                            navigate('/dashboard/queries');
                          } else if (type === 'complaint') {
                            navigate('/dashboard/complaints');
                          } 
                          // Navigate based on bookingType
                          else if (bookingType === 'flight') {
                            navigate('/dashboard/flight-booking');
                          } else if (bookingType === 'hotel') {
                            navigate('/dashboard/hotel-booking');
                          } else if (bookingType === 'tour') {
                            navigate('/dashboard/tour-booking');
                          }
                        };
                        
                        return (
                          <ul className="timeline" key={data?._id}>
                            <li>
                              <div onClick={handleItemClick} style={{ cursor: 'pointer' }} className="timeline-panel">
                                <div className="media me-2 media-info">KG</div>
                                <div className="media-body">
                                  <h6 className="mb-1">{data?.message}</h6>
                                  <small className="d-block">{formatDate(data?.createdAt)}</small>
                                </div>
                                <div onClick={() => handleDeleteById(data?._id)} style={{ cursor: 'pointer' }}>
                                  <MdDeleteOutline style={{ fontSize: '20px' }} />
                                </div>
                              </div>
                            </li>
                          </ul>
                        );
                      })
                    )}
                  </PerfectScrollbar>
                  {notifications?.length > 0 && (
                    <button className="all-notification" onClick={handleDeleteAll}>
                      Clear all notifications <i className="ti-arrow-right" />
                    </button>
                  )}
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
                  <img
                    width={20}
                    src={employee?.image || `https://ui-avatars.com/api/?name=${employee?.name}`}
                    alt=""
                  />{' '}
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-3 dropdown-menu w-full dropdown-menu-end">
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
